import { ZENCLEAR, ZENCLEAR_LITE, ZENPLUS } from 'types/TPVForm.types';

import {
  DELIVERY_INFO_STATUS,
  PRODUCTION_RECORD_STATUS,
  TREATMENT_PLAN_VERSION_STATUS
} from './options';

const MOBILE_SCREEN_WIDTH = 768;
const TAB_SCREEN_WIDTH = 1200;
export enum APP_LANGUAGES {
  EN = 'en'
}

export const SMARTEE_HTTP_URL = 'http://check.zenyumsmileplans.com/';
export const TOOTHSI_IFRAME_PROXY_URLS = [
  {
    origin: 'https://ap.lingoral.com/dental-3dstudio/',
    version: 'v1'
  },
  {
    origin: 'https://ap-dentalcraft.lingoral.com/dental-3dstudio-technician/',
    version: 'v2'
  }
] as const;
export const ZOOM_PHONE_ORIGIN = 'https://applications.zoom.us';
export const INTERCOM_APP_HOST = 'app.intercom.com';
export const KEEP_PLAN_OPENED = 'keepOpened';

export enum TPV_PAGE_CLICK_SOURCE {
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
  PATIENT_CARD = 'PATIENT_CARD',
  TPV_SWAPPER = 'TPV_SWAPPER'
}

export enum PATIENT_PAGE_SOURCE {
  QR_CODE = 'qrcode'
}

export enum DASHBOARD_TASKS_TYPE {
  RETAINER = 'RETAINER',
  ALIGNER = 'ALIGNER'
}

export const NO_EMAIL = 'noemail.com';

const CLINIC_CLOUD = 'Clinic Cloud';
const ZENBASE = 'ZenBase';

const REFERRAL_STATUS_VALID = 'VALID';
const REFERRAL_STATUS_WARNING = 'WARNING';
const REFERRAL_STATUS_DUPLICATE = 'DUPLICATE';
const REFERRAL_STATUS_INVALID = 'INVALID';

const CHAT_WITH_ZENYUM = 'CHAT_WITH_ZENYUM';
const REFINEMENT = 'refinement';
const ZENSTAGES = 'zenstages';
const TRIMMING = 'trimming';
const ILL_FITTING_ALIGNERS = 'ill-fitting_aligners';
export const MULTI_TAB_SYNC_STORAGE_KEY = 'syncTabs';

export {
  CHAT_WITH_ZENYUM,
  CLINIC_CLOUD,
  ZENBASE,
  REFINEMENT,
  ILL_FITTING_ALIGNERS,
  ZENSTAGES,
  TRIMMING
};
const USER_ROLES = {
  DOCTOR: 'DOCTOR',
  NURSE: 'NURSE',
  SUPER_ADMIN: 'SUPER_ADMIN',
  CLINIC_ADMIN: 'CLINIC_ADMIN',
  AFTERSALES_DOCTOR: 'AFTERSALES_DOCTOR',
  CS_ADMIN: 'CS_ADMIN',
  CC_ADMIN: 'CC_ADMIN',
  SALES_OPERATIONS: 'SALES_OPERATIONS',
  OTHERS: 'OTHERS',
  EXTERNAL_DOCTOR: 'EXTERNAL_DOCTOR',
  TREATMENT_PLANNING_DOCTOR: 'TREATMENT_PLANNING_DOCTOR',
  TREATMENT_PLANNING_LEAD: 'TREATMENT_PLANNING_LEAD',
  CUSTOMER_CARE: 'CUSTOMER_CARE',
  OPERATIONS_DENTISTRY: 'OPERATIONS_DENTISTRY',
  PARTNERSHIP_MANAGER: 'PARTNERSHIP_MANAGER',
  PRE_ASSESSMENT_LEAD: 'PRE_ASSESSMENT_LEAD',
  PRE_ASSESSMENT_DOCTOR: 'PRE_ASSESSMENT_DOCTOR',
  PATIENT: 'PATIENT',
  CASE_OPERATIONS: 'CASE_OPERATIONS',
  CASE_OPERATIONS_ADMIN: 'CASE_OPS_ADMIN',
  ADMIN: 'ADMIN',
  CUSTOMER_SUCCESS: 'CUSTOMER_SUCCESS',
  CHAT_OWNER: 'CHAT_OWNER',
  INTERNAL_DOCTOR: 'INTERNAL_DOCTOR',
  CLINICAL_TRAINER: 'CLINICAL_TRAINER',
  CLINICAL_TRAINER_HQ: 'CLINICAL_TRAINER_HQ',
  PATIENT_CARE_LEAD: 'PATIENT_CARE_LEAD',
  ZENYUM_COUNCIL_ADMIN: 'ZENYUM_COUNCIL_ADMIN',
  TP_COUNCIL: 'TP_COUNCIL',
  EMPLOYEE: 'EMPLOYEE',
  FINANCE: 'FINANCE',
  TOOTHSI_ADMIN: 'TOOTHSI_ADMIN'
};
export const EXTERNAL_ROLES = [
  USER_ROLES.NURSE,
  USER_ROLES.EXTERNAL_DOCTOR,
  USER_ROLES.CLINIC_ADMIN,
  USER_ROLES.OTHERS
];
export const INTERNAL_ROLES = [
  USER_ROLES.CUSTOMER_CARE,
  USER_ROLES.CASE_OPERATIONS,
  USER_ROLES.CUSTOMER_SUCCESS,
  USER_ROLES.PRE_ASSESSMENT_LEAD,
  USER_ROLES.AFTERSALES_DOCTOR,
  USER_ROLES.SALES_OPERATIONS,
  USER_ROLES.PARTNERSHIP_MANAGER,
  USER_ROLES.PRE_ASSESSMENT_DOCTOR,
  USER_ROLES.TREATMENT_PLANNING_LEAD,
  USER_ROLES.TREATMENT_PLANNING_DOCTOR,
  USER_ROLES.OPERATIONS_DENTISTRY,
  USER_ROLES.CLINICAL_TRAINER,
  USER_ROLES.CLINICAL_TRAINER_HQ,
  USER_ROLES.CASE_OPERATIONS_ADMIN,
  USER_ROLES.CC_ADMIN,
  USER_ROLES.CS_ADMIN,
  USER_ROLES.PATIENT_CARE_LEAD,
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.ZENYUM_COUNCIL_ADMIN,
  USER_ROLES.TP_COUNCIL
];

// temp work around for translation
const TREATMENT_STATUS = {
  COMPLETE: 'status.treatment_complete',
  PENDING_OFF_BOARDING: 'status.pending_patient_off_boarding_approval',
  PENDING_DOCTOR_REVIEW: 'status.pending_doctor_review',
  PENDING_RETAINER_SCANS: 'status.pending_retainer_scans_upload',
  PENDING_EOT_DISCUSSION: 'status.pending_EOT_discussion',
  PENDING_ZENYUM_COUNCIL_ASSESSMENT: 'status.pending_zenyum_council_assessment',
  PENDING_PRESCRIPTION: 'status.pending_prescription',
  IN_TREATMENT: 'status.in_treatment',
  TERMINATED: 'status.terminated',
  LAST_ALIGNER_SWITCH: 'status.last_aligner_switch',
  REFUNDED: 'status.refunded',
  PENDING_INSTRUCTION_UPDATES: 'status.pending_instruction_updates',
  MIA_WITHOUT_FITTING: 'status.mia_without_fitting'
};

export const INACTIVE_STATUS = [
  TREATMENT_STATUS.TERMINATED,
  TREATMENT_STATUS.REFUNDED,
  TREATMENT_STATUS.MIA_WITHOUT_FITTING
];

export const INACTIVE_STATUS_CONTENT = {
  [TREATMENT_STATUS.TERMINATED]: {
    title: 'patient.terminated',
    message: 'patient.terminated.message'
  },
  [TREATMENT_STATUS.REFUNDED]: {
    title: 'calendar.cancelled',
    message: 'patient.cancelled.message'
  },
  [TREATMENT_STATUS.MIA_WITHOUT_FITTING]: {
    title: 'patient.mia_without_fitting',
    message: 'patient.mia_without_fitting.message'
  }
};

export const STAGES = {
  PENDING_PRESCRIPTION: 'PENDING_PRESCRIPTION',
  TREATMENT_PLAN_REVIEW: 'TREATMENT_PLAN_REVIEW',
  ALL_ALIGNERS: 'ALL_ALIGNERS'
};

export const stages = {
  PENDING_PRESCRIPTION: 'Pending prescription'
};

export const TREATMENT_STATUSES = {
  PENDING_CONSULTATION_APPOINTMENT: 'status.pending_consultation_appointment',
  CONSULTATION_APPOINTMENT_BOOKED: 'status.consultation_appointment_booked',
  CONSULTATION_APPOINTMENT_OVERDUE: 'status.consultation_appointment_overdue',
  PENDING_DOCTOR_ASSESSMENT: 'status.pending_doctor_assessment',
  DISCUSSION_REQUIRED: 'status.pending_discussion',
  PATIENT_ACCEPTED_PENDING_FITTING_APPOINTMENT:
    'status.patient_accepted__pending_fitting_appointment',
  FITTING_APPOINTMENT_BOOKED: 'status.fitting_appointment_booked',
  PENDING_CONSENT_FORM: 'status.pending_consent_upload',
  CREATION_IN_PROGRESS: 'status.creation_in_progress',
  PENDING_PRESCRIPTION: 'status.pending_prescription',
  RESUBMIT_SCAN: 'status.resubmit_scan',
  WAITING_ALIGNER_TREATMENT: 'status.waiting_for_aligner_treatment',
  APPOINTMENT_BOOKED: 'status.appointment_booked'
};

export enum TREATMENT_STATUS_VALUES {
  PENDING_DOCTOR_ASSESSMENT = 'PENDING_DOCTOR_ASSESSMENT',
  TREATMENT_COMPLETE = 'TREATMENT_COMPLETE',
  PENDING_RETAINER_SCANS_UPLOAD = 'PENDING_RETAINER_SCANS_UPLOAD'
}

export const RETAINER_PRESCRIPTION_ENABLED_STATUS = [
  TREATMENT_STATUSES.PENDING_PRESCRIPTION,
  TREATMENT_STATUSES.RESUBMIT_SCAN,
  TREATMENT_STATUSES.APPOINTMENT_BOOKED
];

export const WHITENING_PRESCRIPTION_ENABLED_STATUS = [
  TREATMENT_STATUSES.PENDING_PRESCRIPTION,
  TREATMENT_STATUSES.APPOINTMENT_BOOKED
];

export {
  REFERRAL_STATUS_VALID,
  REFERRAL_STATUS_WARNING,
  REFERRAL_STATUS_DUPLICATE,
  USER_ROLES,
  MOBILE_SCREEN_WIDTH,
  TAB_SCREEN_WIDTH,
  TREATMENT_STATUS,
  REFERRAL_STATUS_INVALID
};
export const DAYS = [
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY'
];

export const INTRAORAL_SCANNER_3SHAPE = 'INTRAORAL_SCANNER_3SHAPE';

export const SCANNER_TYPE_VALUES = [
  'INTRAORAL_SCANNER_3SHAPE',
  'INTRAORAL_SCANNER_ITERO',
  'INTRAORAL_SCANNER_OTHERS'
];

export const EXCLUDE_ROLES = ['CHAT_OWNER', 'AB_CHALLENGER'];

export const ROLES: Record<string, string> = {
  EXTERNAL_DOCTOR: 'Doctor',
  NURSE: 'Nurse',
  EMPLOYEE: 'Employee',
  CUSTOMER_CARE: 'Customer Care',
  CASE_OPERATIONS: 'Case Operations',
  CUSTOMER_SUCCESS: 'Customer Success',
  AFTERSALES_DOCTOR: 'Aftersales Doctor',
  PRE_ASSESSMENT_LEAD: 'Pre-assessment lead',
  PRE_ASSESSMENT_DOCTOR: 'Pre-assessment Doctor',
  PARTNERSHIP_MANAGER: 'Partnership Manager',
  OPERATIONS_DENTISTRY: 'Operations Dentistry',
  TREATMENT_PLANNING_LEAD: 'Treatment Planning Lead',
  TREATMENT_PLANNING_DOCTOR: 'Treatment Planning Doctor',
  CC_ADMIN: 'Cc Admin',
  CLINICAL_TRAINER: 'Clinical Trainer',
  CLINICAL_TRAINER_HQ: 'Clinical Trainer HQ',
  CLINIC_ADMIN: 'Clinic Admin',
  CS_ADMIN: 'CS Admin',
  OTHERS: 'Others',
  ZENYUM_COUNCIL_ADMIN: 'Zenyum Council Admin',
  PATIENT_CARE_LEAD: 'Patient Care Lead',
  CASE_OPS_ADMIN: 'Case Operations Admin',
  TOOTHSI_ADMIN: 'Toothsi Admin'
};

export const DEFAULT_REFERRAL_BONUS = 'S$650';

export const BothTreatmentPlans = 'both';
export const ZenPlus = 'ZENCLEAR_PLUS';
export const ZenClear = 'ZENCLEAR';
export const ZenClearLite = 'ZENCLEAR_LITE';
export const ZenClearUltra = 'ZENCLEAR_ULTRA';
export const ZenClearExtra = 'ZENCLEAR_EXTRA';
export const TREATMENT_TYPE: { [key: string]: string } = {
  [ZENCLEAR]: 'ZenClear',
  [ZENCLEAR_LITE]: 'ZenClearLite',
  [ZENPLUS]: 'ZenPlus',
  [ZenClearUltra]: 'ZenClearUltra'
};

export const STATUS_CODE = {
  BOOKED: 'BOOKED'
};
export const NONEVALUE = 'None';
export const EXISTING_PHOTO = 'existingPhoto';
export enum COUNTRY_CODE {
  SINGAPORE = 'SG',
  INDONESIA = 'ID',
  MACAU = 'MO'
}
export const WIDTH_768 = 768;
export const ALLOWED_PHOTO_MIME_TYPE =
  'image/jpeg, image/png, image/jpg, image/jp2';

export const ALLOWED_FILE_MIME_TYPE =
  'image/jpeg, image/png, image/jpg, application/pdf';

export const ALLOWED_ZIP_MIME_TYPE =
  'application/zip, application/x-zip-compressed';

export enum YES_NO {
  YES = 'YES',
  NO = 'NO'
}

export const YES_NO_MAPPER: Record<string, boolean> = {
  [YES_NO.YES]: true,
  [YES_NO.NO]: false
};

export enum EXTENSIONS {
  STL = '.stl'
}

export const ACCEPTANCE_STATUS = {
  REJECTED: 'REJECTED',
  ACCEPTED: 'PATIENT_ACCEPTED'
};

export const EXTERNAL_DOCTOR = 'TREATING_DOCTOR';
export const INTERNAL_DOCTOR = 'INTERNAL_DOCTOR';
export const PATIENT = 'PATIENT';

export const ROLES_TO_EXCLUDE = ['CHAT_OWNER'];

export const EMAIL_REGEX =
  /^\s*(([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5}){1,25})+([;.](([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5}){1,25})+)*\s*$/;

export const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'obj', 'stl', 'pdf'];

export const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'jp2'];

export const ALLOWED_VIDEO_EXTENSIONS = [
  'mp4',
  'avi',
  'mkv',
  'mov',
  'wmv',
  'flv',
  'webm',
  '3gp',
  'mpeg',
  'm4v',
  'ts',
  'ogv'
];

export enum TREATMENT_PLAN_TYPES {
  ZENCLEAR = 'ZenyumClear',
  ZENCLEAR_PLUS = 'ZenyumClear Plus',
  ZENCLEAR_LITE = 'ZenClear Lite',
  ZENCLEAR_ULTRA = 'ZenyumClear Ultra'
}

export enum TREATMENT_PLANNING_LAB {
  SMARTEE = 'Smartee',
  FULLCONTOUR = 'FullContour',
  TOOTHSI = 'Toothsi'
}

export const KEYBOARD_KEYS = {
  ENTER: 'Enter',
  BACKSPACE: 'Backspace'
};
export const CLINIC_SWAP_CONSTANTS = {
  EMAIL: 'EMAIL',
  PATH: '/tpv/'
};

export const IN_PLANNING_STATUSES = [
  TREATMENT_PLAN_VERSION_STATUS.IN_PLANNING,
  TREATMENT_PLAN_VERSION_STATUS.CASE_IN_PLANNING,
  TREATMENT_PLAN_VERSION_STATUS.CASE_WITH_ZENYUM,
  TREATMENT_PLAN_VERSION_STATUS.CASE_OPS_TPV_CHECK,
  TREATMENT_PLAN_VERSION_STATUS.CASE_WITH_INT_DOC
];

export enum SORT_ORDER {
  ASC = 'ASC',
  DESC = 'DESC'
}

export const TREATMENT_PLANNING_TEMPLATE = 'TREATMENT_PLANNING_TEMPLATE';
export const CLINICAL_PREFERENCE = 'CLINICAL_PREFERENCE';
export const TEMPLATIZED_PRESCRIPTION = 'TEMPLATIZED_PRESCRIPTION';
export const FEATURE_WALKTHROUGH = 'FEATURE_WALKTHROUGH';
export const AUTO_INTERNAL_TPV_APPROVAL = 'AUTO_INTERNAL_TPV_APPROVAL';
export const NOTIFICATION_PREFERENCE = 'NOTIFICATION_PREFERENCE';
export const ZENCHAT_VISIBILITY = 'ZENCHAT_VISIBILITY';
export const CBCT_ENABLED = 'CBCT_ENABLED';
export const ACCEPTED_IMAGE_FORMATS = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/jp2'
];

export const ACCEPTED_FILE_FORMATS = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/jp2',
  'application/pdf',
  'application/zip',
  'application/x-zip-compressed'
];

export const ALLOWED_FILE_UPLOAD_MIME_TYPE =
  'image/jpeg, image/png, image/jpg, image/jp2, application/pdf, application/zip, application/x-zip-compressed';
export const LIVE_TRANSLATION_HIDDEN_COUNTRIES = [
  'SG',
  'MY',
  'TW',
  'ID',
  'HK',
  'MO'
];
export const SKIP_INT_DOC_REJECTION_REASONS = {
  PLAN_TO_BE_RESIMULATED: 'PLAN_TO_BE_RESIMULATED',
  PREV_PLAN_MORE_SUITABLE: 'PREV_PLAN_MORE_SUITABLE',
  PATIENT_NEED_TP_UPGRADE: 'PATIENT_NEED_TP_UPGRADE',
  CANNOT_TREAT_PATIENT: 'CANNOT_TREAT_PATIENT'
};

export const REJECTION_REASON_API = {
  PATIENT_REQUIRE_DIFFERENT_TP: 'PATIENT_REQUIRE_DIFFERENT_TP'
};
export const LIVE_TRANSLATION_VISIBLE_REJECT_REASONS = [
  SKIP_INT_DOC_REJECTION_REASONS.CANNOT_TREAT_PATIENT,
  SKIP_INT_DOC_REJECTION_REASONS.PATIENT_NEED_TP_UPGRADE,
  SKIP_INT_DOC_REJECTION_REASONS.PLAN_TO_BE_RESIMULATED
];
export const TREATMENT_PLAN_TYPE_ORDER: Record<string, number> = {
  [ZenClearLite]: 0,
  [ZenClear]: 1,
  [ZenPlus]: 2,
  [ZenClearUltra]: 3
};

export const TREATMENT_PLAN_TYPE_OPTIONS = [
  {
    label: 'prescriptions.zenyumclear_lite',
    value: ZenClearLite,
    order: TREATMENT_PLAN_TYPE_ORDER[ZenClearLite]
  },
  {
    label: 'prescriptions.zenyumclear',
    value: ZenClear,
    order: TREATMENT_PLAN_TYPE_ORDER[ZenClear]
  },
  {
    label: 'prescriptions.zenyumclear_plus',
    value: ZenPlus,
    order: TREATMENT_PLAN_TYPE_ORDER[ZenPlus]
  },
  {
    label: 'prescriptions.zenyumclear_ultra',
    value: ZenClearUltra,
    order: TREATMENT_PLAN_TYPE_ORDER[ZenClearUltra]
  }
  // {
  //   label: 'product_type.zenyum_extra',
  //   value: ZenClearExtra
  // }
];

export const IN_PRODUCTION_STATUSES = [
  PRODUCTION_RECORD_STATUS.IN_PRODUCTION,
  PRODUCTION_RECORD_STATUS.TRIMMING,
  PRODUCTION_RECORD_STATUS.READY_FOR_SHIPMENT,
  PRODUCTION_RECORD_STATUS.SHIPPED
];
export const DELIVERY_INFO_MESSAGES: Record<string, string> = {
  Production: 'Production.Info.Message',
  Warehouse: 'Warehouse.Info.Message',
  Dispatched: 'Dispatched.Info.Message',
  Received: 'Received.Info.Message'
};
export const DELIVERY_INFO_STATUSES = [
  DELIVERY_INFO_STATUS.PRODUCTION,
  DELIVERY_INFO_STATUS.WAREHOUSE,
  DELIVERY_INFO_STATUS.DISPATCHED,
  DELIVERY_INFO_STATUS.RECEIVED
];
export const DELIVERY_INFO_STATUSES_LABEL: Record<string, string> = {
  Production: 'deliveryInfo.Production',
  Warehouse: 'deliveryInfo.Warehouse',
  Dispatched: 'deliveryInfo.Dispatched',
  Received: 'deliveryInfo.Received'
};
export const PRODUCTION_STATUSES_IGNORED = [
  'UPLOAD_DESIGN_FILES',
  'TO_BE_REVIEWED',
  'WAITING_FOR_PRODUCTION',
  'TO_BE_PRODUCED'
];

export const TREATMENT_PLAN_STATUS = {
  PRESCRIPTION_PENDING: 'PRESCRIPTION_PENDING',
  PRESCRIPTION_REUSED: 'PRESCRIPTION_REUSED'
};

export const TREATMENT_NAME_MAPPER: Record<string, string> = {
  BRACES: 'sidepanel_appointmentlist.primary',
  AFTERSALES: 'sidepanel_appointmentlist.primary',
  REFINEMENT: 'prescriptions.refinement',
  REFINEMENT_AOC: 'prescriptions.refinement',
  RETAINER: 'retainer.retainer',
  ZENYUM_RETAINER: 'retainer.retainer',
  TEMP_ALIGNER: 'temp_aligner.temp_aligner',
  WHITENING: 'whitening.whitening'
};

export const TIME_PICKER_CONFIG = {
  isFormSelect: true,
  menuMinWidth: 'auto',
  showClockIcon: true,
  showDropDownIcon: true,
  inputWidth: '3rem'
};

export const DAYS_OF_WEEK = {
  SUNDAY: 'day.sunday',
  MONDAY: 'day.monday',
  TUESDAY: 'day.tuesday',
  WEDNESDAY: 'day.wednesday',
  THURSDAY: 'day.thursday',
  FRIDAY: 'day.friday',
  SATURDAY: 'day.saturday'
};

export const DISABLED_APPBAR_NAVBAR_ROUTES = ['/tpv-preview'];

export const APPOINTMENT_OUTCOME_LABEL: Record<string, string> = {
  ILL_FITTING_AT_FITTING: 'ill-fitting',
  SUCCESS: 'Success',
  OTHER_ISSUES: 'Other issues'
};

export const APPOINTMENT_STATUS_LABEL: Record<string, string> = {
  NO_SHOW: 'No show',
  SHOW_UP: 'Show up',
  RESCHEDULED: 'Rescheduled',
  SCHEDULED: 'Scheduled',
  BOOKED: 'Booked',
  CONFIRMED: 'Confirmed'
};

export const COUNTRY_TRANSLATION_MAP: Record<string, string> = {
  SG: 'Singapore',
  HK: 'Hong Kong',
  MO: 'Macau',
  MY: 'Malaysia',
  ID: 'Indonesia',
  JP: 'Japan',
  KR: 'Korea',
  TW: 'Taiwan',
  TH: 'Thailand',
  VN: 'Vietnam'
};

/** Uppercased country name → ISO code (inverse of COUNTRY_TRANSLATION_MAP). */
export const COUNTRY_NAME_TO_CODE_MAP: Record<string, string> =
  Object.fromEntries(
    Object.entries(COUNTRY_TRANSLATION_MAP).map(([code, name]) => [
      name.toUpperCase(),
      code
    ])
  );

/** Normalize a country name or code to a 2-letter ISO country code. */
export const normalizeCountryCode = (value?: string | null): string => {
  if (!value) return '';
  const normalized = value.trim().toUpperCase();
  if (normalized.length === 2) return normalized;
  return COUNTRY_NAME_TO_CODE_MAP[normalized] || normalized.slice(0, 2);
};

export const YES_NO_OPTIONS = [
  { value: true, label: 'yes.yes' },
  { value: false, label: 'no.no' }
];

/** String-valued Yes/No options for selects that compare against `'true'`/`'false'`. */
export const YES_NO_BOOLEAN_OPTIONS = YES_NO_OPTIONS.map((option) => ({
  ...option,
  value: String(option.value)
}));

export const CONSENT_FORM_BUTTON_DISABLED_COUNTRIES = ['TW', 'SG', 'MY'];

export const UDI_DI_NUMBERS: Record<string, string> = {
  TW: 'UDI-DI 06974361426523'
};
